import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=03c5398c&"
import script from "./../ts/spinner.ts?vue&type=script&lang=js&"
export * from "./../ts/spinner.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/spinner.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports